module.exports = __webpack_public_path__ + "img/book_shouhou.2e802369.png";